// TODO: move all home-page helpers to this file

import {UserActivityCategoryEnum} from '@mobi-components/global-solution';
import {FilterTag} from '../../app-types';
import {Trip} from '@/store/api/download-destination-trips';

export const allovedInterestDomains = [
  UserActivityCategoryEnum.ACCOMMODATION,
  UserActivityCategoryEnum.DINING,
  UserActivityCategoryEnum.EXPERIENCE,
  UserActivityCategoryEnum.TRIPPREFERENCE,
  UserActivityCategoryEnum.GEOLOCATION,
];

export const emptyTrip = {
  id: '',
  tags: [],
  images: {
    medium: '',
  },
  accommodations: [],
  flights: [],
  pois: 0,
  prices: [],
};

export const emptyCardsRow = [
  {...emptyTrip, id: '1'},
  {...emptyTrip, id: '2'},
  {...emptyTrip, id: '3'},
  {...emptyTrip, id: '4'},
];

// Tags helpers
export const getSelectedTags = (tags: FilterTag[]) => tags.filter((tag) => tag.value);

export const getFlightsTags = (tags: FilterTag[]) => {
  return tags.filter((tag) => tag.domain === UserActivityCategoryEnum.TRANSPORTATION && tag.name);
};

export const getHotelImage = (x: Trip) => {
  const hotels = x.accommodations || [];
  const hotelImgs = (hotels.length && hotels[0].images) || null;
  const hotelImg = hotelImgs
    ? Object.keys(hotelImgs).map((k) => hotelImgs[k])
    : Object.keys(x.context.images).map((k) => x.context.images[k]);
  return {
    ...x,
    pois: (x.pois || []).length,
    images: hotelImg,
    id: x.trip_id,
    flightsMessage: x.flight_optional ? 'Flights are not needed' : 'No Flights Available',
  };
};

export const mapToFilterTag = (x: FilterTag, index: number) => ({
  name: x.name,
  key: index,
  isActive: x.value,
});
